import { createSlice } from '@reduxjs/toolkit';

import { SLICER_KEYS } from 'types/services';
import { setConditions } from './reducers/setConditions';
import { updateCondition } from './reducers/updateCondition';
import { addConditionToIndex } from './reducers/addConditionToIndex';
import { removeConditionFromIndex } from './reducers/removeConditionFromIndex';
import { dynamicallyUpdateBase } from './reducers/updateBase';
import type { TemplateType } from 'types/helios/templateForms';
import type { NotificationCondition } from 'types/templateNotificationConditions';

export interface HeliosNotificationConditionsBaseState {
  name: string;
  description: string;
  conditions: NotificationCondition[];
  parametrs: HeliosNotificationConditionParameter[];
  notificationTemplateId: string;
  templateId: string;
  realTimeTemplateFunctions: { templateFunctionId: string; isTask: boolean }[];
  type: keyof typeof TemplateType;
  notificationIsTask: boolean;
}

export interface HeliosNotificationConditionParameter {
  parametr: string;
  staticValue: string | null;
  templateDataItemId: number | null;
  templatePresentationItemId?: string | null;
}

export interface HeliosNotificationFormValues {
  name: string;
  description: string;
  notificationTemplateId: string | null;
  type: keyof typeof TemplateType;
  templateId: string | null;
  conditions: NotificationCondition[];
  realTimeTemplateFunctions: { templateFunctionId: string; isTask: boolean }[];
  parametrs: HeliosNotificationConditionParameter[];
  notificationIsTask: boolean;
}

export interface HeliosNotificationConditionsState {
  PRE?: HeliosNotificationConditionsBaseState;
  CURRENT?: HeliosNotificationConditionsBaseState;
}

export type ConditionType = 'PRE' | 'CURRENT';

const initialState: HeliosNotificationConditionsState = {
  PRE: {
    name: '',
    description: '',
    type: 'Edit',
    conditions: [],
    parametrs: [],
    notificationTemplateId: '',
    templateId: '',
    realTimeTemplateFunctions: [],
    notificationIsTask: false,
  },
  CURRENT: {
    name: '',
    description: '',
    type: 'Edit',
    conditions: [],
    parametrs: [],
    notificationTemplateId: '',
    templateId: '',
    realTimeTemplateFunctions: [],
    notificationIsTask: false,
  },
};

export const heliosNotificationConditionsState = createSlice({
  name: SLICER_KEYS.HELIOS_NOTIFICATION_CONDITIONS,
  initialState,
  reducers: {
    setConditions,
    updateCondition,
    addConditionToIndex,
    removeConditionFromIndex,
    dynamicallyUpdateBase,
  },
});

export const heliosNotificationConditionsStateActions = heliosNotificationConditionsState.actions;
